import { render, staticRenderFns } from "./adminRoleEditor.vue?vue&type=template&id=9227cb62&"
import script from "./adminRoleEditor.vue?vue&type=script&lang=js&"
export * from "./adminRoleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports